import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetNotificationByIdQuery } from "../../service/features/api";
import moment from "moment";

const getRecipientLabel = (type: number) => {
  switch (Number(type)) {
    case 1:
      return "All";
    case 2:
      return "Customers";
    case 3:
      return "Dealers";
    default:
      return "-";
  }
};

const NotificationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: response, isLoading } = useGetNotificationByIdQuery(id);
  const data = response?.data;

  return (
    <>
      <CommonBreadcrumb
        title="Notification Detail"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          {
            label: "Notification Management",
            onClick: () => navigate("/manage-notifications"),
          },
          { label: "Notification Detail" },
        ]}
      />

      <div className="cards view_page">
        {isLoading ? (
          <div className="loading_msg">Loading...</div>
        ) : data ? (
          <div className="gap_p">
            <div className="vew_img no_radius w_100">
              <h6>Image</h6>
              <figure>
                <img
                  alt="notification"
                  src={data.image || "/static/images/placeholder.png"}
                />
              </figure>
            </div>
            <div className="w_100">
              <h6>Notification Title</h6>
              <p>{data.title}</p>
            </div>
            <div className="w_33">
              <h6>Type</h6>
              <p>{data.type}</p>
            </div>
            <div className="w_33">
              <h6>Recipients</h6>
              <p>
                {getRecipientLabel(data.recipientType)} ({data.recipientCount})
              </p>
            </div>
            <div className="w_33">
              <h6>Created Date</h6>
              <p>
                {data.createdAt
                  ? moment(data.createdAt).format("DD-MMM-YYYY")
                  : "-"}
              </p>
            </div>
            <div className="w_100">
              <h6>Notification Message</h6>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.message,
                }}
              />
            </div>
          </div>
        ) : (
          <div className="error_msg">Notification not found</div>
        )}
      </div>
    </>
  );
};

export default NotificationDetail;
